"use client";

import { useEffect, useRef, useState } from "react";

const STORAGE_KEY = "shkc-human.rememberedUsername";

export function LoginForm({
  action,
  error,
}: {
  action: (formData: FormData) => void | Promise<void>;
  error?: string;
}) {
  const [remember, setRemember] = useState(true);
  const userRef = useRef<HTMLInputElement>(null);
  const passRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && userRef.current) {
      userRef.current.value = saved;
      setTimeout(() => passRef.current?.focus(), 30);
    }
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const username = userRef.current?.value ?? "";
    if (remember && username) {
      localStorage.setItem(STORAGE_KEY, username);
    } else if (!remember) {
      localStorage.removeItem(STORAGE_KEY);
    }
    void e;
  };

  const fieldCls = "w-full px-3 py-2.5 border border-stone-300 rounded-lg text-sm bg-white text-stone-800 placeholder:text-stone-400 transition-colors hover:border-stone-400 focus:border-brand-600 focus:outline-none";

  return (
    <form action={action} onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-stone-500 mb-1.5 tracking-wide uppercase">帳號</label>
        <input
          ref={userRef}
          name="username"
          type="text"
          autoComplete="username"
          required
          className={fieldCls}
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-stone-500 mb-1.5 tracking-wide uppercase">密碼</label>
        <input
          ref={passRef}
          name="password"
          type="password"
          autoComplete="current-password"
          required
          className={fieldCls}
        />
      </div>

      <label className="flex items-center gap-2 text-sm text-stone-500 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={remember}
          onChange={(e) => setRemember(e.target.checked)}
          className="w-4 h-4 accent-brand-600"
        />
        <span>記住帳號</span>
      </label>

      {error && (
        <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2.5">
          {error === "CredentialsSignin" ? "帳號或密碼錯誤" : "登入失敗，請再試一次"}
        </div>
      )}

      <button
        type="submit"
        className="w-full py-2.5 rounded-lg bg-brand-600 text-white text-sm font-medium tracking-wide hover:bg-brand-700 active:bg-brand-800 transition-colors shadow-sm"
      >
        登入
      </button>
    </form>
  );
}
